import React from 'react';
import ISkeletonLoader from './ISkeletonLoader';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

const SkeletonLoader: React.FunctionComponent<ISkeletonLoader> = (props) => {

  return (
    props.purple ? (
      <SkeletonTheme color="#81109c" highlightColor="#a351b7">
        <Skeleton {...props} />
      </SkeletonTheme>
    ) : <Skeleton {...props} />
  );
};

export default SkeletonLoader;
